var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', [!_vm.printRead ? _c('div', {
    staticClass: "res-checkbox"
  }, [_vm.options.length && _vm.isButton ? [_c('el-checkbox-group', _vm._g(_vm._b({
    attrs: {
      "disabled": !_vm.edit || _vm.disabled
    },
    on: {
      "change": _vm.checkboxChange
    },
    model: {
      value: _vm.dataModel,
      callback: function ($$v) {
        _vm.dataModel = $$v;
      },
      expression: "dataModel"
    }
  }, 'el-checkbox-group', _vm.$attrs, false), _vm.$listeners), _vm._l(_vm.options, function (item) {
    return _c('el-checkbox-button', {
      key: item[_vm.valueKey],
      attrs: {
        "label": item[_vm.valueKey],
        "disabled": item.disabled
      }
    }, [_vm._v(" " + _vm._s(item[_vm.labelKey]) + " ")]);
  }), 1)] : _vm._e(), _vm.options.length && !_vm.isButton ? [_vm.indeterminate ? _c('el-checkbox', {
    staticClass: "m-b-15",
    attrs: {
      "indeterminate": _vm.isIndeterminate,
      "disabled": !_vm.edit || _vm.indeterminateDisable
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: _vm.checkAll,
      callback: function ($$v) {
        _vm.checkAll = $$v;
      },
      expression: "checkAll"
    }
  }, [_vm._v(" 全选 ")]) : _vm._e(), _c('el-checkbox-group', _vm._g(_vm._b({
    class: _vm.layout == 'vertical' ? 'res-checkbox__vertical' : '',
    attrs: {
      "disabled": !_vm.edit || _vm.disabled
    },
    on: {
      "change": _vm.checkboxChange
    },
    model: {
      value: _vm.dataModel,
      callback: function ($$v) {
        _vm.dataModel = $$v;
      },
      expression: "dataModel"
    }
  }, 'el-checkbox-group', _vm.$attrs, false), _vm.$listeners), _vm._l(_vm.options, function (item) {
    return _c('el-checkbox', {
      key: item[_vm.valueKey],
      attrs: {
        "label": item[_vm.valueKey],
        "disabled": item.disabled,
        "border": _vm.border
      }
    }, [_vm._v(" " + _vm._s(item[_vm.labelKey]) + " ")]);
  }), 1)] : _vm._e()], 2) : _c('div', {
    staticClass: "res-checkbox"
  }, [_c('div', {
    staticClass: "res-print-read m-l-5"
  }, [_vm._v(_vm._s(_vm.valueToLabel))])]), _vm.description ? _c('div', {
    staticClass: "cmp-desc"
  }, [_vm._v(" " + _vm._s(_vm.description) + " ")]) : _vm._e()]);
};

var staticRenderFns = [];
export { render, staticRenderFns };